import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NoDataTypes, NoDataSourceType } from '../../interfaces/no-data';
import { ILargeCardInteriorOptions, IChartTitleData } from '../../interfaces/card-data';
import { UserAccessService } from '../../services/user-access.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CustomDashboardsService } from '../../../my-limegear/services/my-limegear.service';
import { NavigationHelpService } from 'app/modules/shared/services/navigation-help.service';
import { ICardControllerInfo } from 'app/modules/shared/components/card-controller-panel/card-controller-panel.component';

@Component({
    selector: 'large-card',
    templateUrl: './large-card.component.html',
    styleUrls: ['./large-card.component.scss'],
})
export class LargeCardComponent implements OnInit, OnChanges {
    @Input() largeCardInteriorOptions?: ILargeCardInteriorOptions;
    // TODO: Add all the below parameters inside the ILargeCardInteriorOptions
    @Input() showMainValue?: boolean = true;
    @Input() showDashboardTextRight?: boolean = true;
    @Input() showDropdown?: boolean = true;
    @Input() showTitle?: boolean = true;
    chartId: string = ''; // TODO: performance-insights-kpi uses this. Pass it through largeCardInteriorOptions
    noDataType: NoDataTypes;
    isDataReady: boolean;
    hasData: boolean;
    showChartCustomTitle: boolean;
    chartTitleData: IChartTitleData;
    hasDrilldownAcess: boolean;
    useLGScroll = false;
    comparisonStyle: object = {};
    cardMinheight = 420;
    cardControllerInfo: ICardControllerInfo;

    constructor(
        private sanitizer: DomSanitizer,
        private router: Router,
        private userAccessService: UserAccessService,
        private customDashboardsService: CustomDashboardsService,
        private navigationHelpService: NavigationHelpService
    ) {}

    ngOnInit() {
        this.showChartCustomTitle = false;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.largeCardInteriorOptions) {
            let change = <ILargeCardInteriorOptions>changes.largeCardInteriorOptions.currentValue;
            this.updateCustomChartTitle();
            this.useLGScroll = change.useLGScroll ? change.useLGScroll : this.useLGScroll;
            let showCardControllers =
                (this.customDashboardsService.hasEditPermission() && change.showCardControlArea) ??
                false;
            this.cardControllerInfo = {
                cardId: change.uniqueId,
                showCardControllers: showCardControllers,
                showDropdown: this.showDropdown,
                cardTitle: change.componentTitle,
            };

            if (change) {
                this.chartId = change.uniqueId;
            }
            this.setData(change);
        } else {
            this.hasData = true;
            this.isDataReady = this.chartId ? true : false;
        }
    }

    setCardHeight() {
        let heightPercent = this.largeCardInteriorOptions?.heightPercent;
        return {
            'min-height': this.cardMinheight.toString() + 'px',
            height: heightPercent ? heightPercent + '%' : '98%',
        };
    }

    updateCustomChartTitle() {
        if (this.largeCardInteriorOptions && this.largeCardInteriorOptions.chartTitleData) {
            let titleData = this.largeCardInteriorOptions.chartTitleData;
            this.hasDrilldownAcess = this.userAccessService.hasAccessToPage(
                this.largeCardInteriorOptions.accessToUrl
            );

            this.chartTitleData = {
                showChartCustomTitle: titleData.showChartCustomTitle,
                chartTile: titleData.chartTile ?? '',
                chartLabelColor: titleData.chartLabelColor ?? '',
                chartComparisonValue: titleData.chartComparisonValue ?? '',
                chartMainValue: titleData.chartMainValue ?? '',
                chartSecondaryValue: titleData.chartSecondaryValue ?? '',
                chartSubItemValue: titleData.chartSubItemValue ?? '',
                isMainValueUnitVisible: titleData.isMainValueUnitVisible,
                isChartSubValueVisible: titleData.isChartSubValueVisible,
                svgIcon: this.sanitizer.bypassSecurityTrustHtml(titleData.svgIconString),
                //showDashboardTextRight: titleData.showDashboardTextRight ?? false,
                mainValueAlignTo: titleData.mainValueAlignTo,
                descriptionText: titleData.descriptionText ?? '',
                showDescriptionText: titleData.showDescriptionText,
                showMainValueToRight: titleData.showMainValueToRight ?? false,
                isDonut: titleData.isDonut ?? false,
                mainValueUnit: titleData.mainValueUnit ?? ' Units',
            };
            this.showChartCustomTitle = titleData.showChartCustomTitle;
            this.showDashboardTextRight =
                titleData.showDashboardTextRight === undefined
                    ? this.showDashboardTextRight
                    : this.chartTitleData.showDashboardTextRight;
            //------------- clean up

            let showMainValue = titleData.showMainValue;
            this.showMainValue =
                showMainValue !== null && showMainValue !== undefined
                    ? showMainValue
                    : this.showMainValue;
            this.comparisonStyle = titleData.comparisonStyle;
        }
    }

    setData(data: ILargeCardInteriorOptions) {
        this.noDataType = {
            action: data.action,
            searchTerm: data.searchTerm,
            componentTitle: data.componentTitle,
            inputSource: NoDataSourceType.chartCard,
            showTitle: data.showTitle,
            noDataCustomMessage: data.noDataCustomMessage,
        };
        if (data.noDataTitleCustomMessage)
            this.noDataType.noDataTitleCustomMessage = data.noDataTitleCustomMessage;
        if (data) {
            this.hasData = data.hasData;
            this.isDataReady = data.isDataReady;
        }
        this.cardMinheight = data.minHeight ?? this.cardMinheight;
    }

    clickTitleValue() {
        if (this.hasDrilldownAcess) {
            this.router.navigate([this.largeCardInteriorOptions.accessToUrl], {
                queryParams: this.largeCardInteriorOptions.queryParams,
            });

            this.navigationHelpService.navigateTo(
                [this.largeCardInteriorOptions.accessToUrl],
                this.largeCardInteriorOptions.queryParams,
                true
            );
        }
    }
}
